<!-- <user-navigation>
  <div class="router-container" fxLayout="row" fxLayoutAlign="center start  r">
    <div class="sidebar" fxFlex="18" *ngIf="!(isHandset | async)!">
      <user-sidenav style="width: 100% !important"></user-sidenav>
    </div>
    <div class="router-wrapper" fxFlex="75" fxFlex.lt-md="100">
      <router-outlet></router-outlet>
    </div>
  </div>
</user-navigation> -->

<mat-drawer-container class="user-sidebar-container">
  <mat-drawer
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) ? false : true"
    #userSidenav
  >
    <user-sidenav />
  </mat-drawer>
  <mat-drawer-content>
    <button mat-icon-button (click)="userSidenav.toggle()" class="user-sidebar-toggle"><mat-icon svgIcon="menu" /></button>
    <div class="container">
      <router-outlet />
    </div>
  </mat-drawer-content>
</mat-drawer-container>